










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class BackgroundCheck extends Vue {
  @Prop(String) colorVariable!: string;
  @Prop({ type: String, default: '#25D7F8' }) color!: string;
  @Prop({ type: String, default: '0 0 300 200' }) viewBox!: string;
  @Prop({ type: String, default: 'M1,1 V199 H57 L299,1 h-63 L40,155 V1z' })
  drawCommand!: string;

  get styles() {
    const color =
      this.$vuetify.theme.currentTheme[this.colorVariable] || this.color;
    return {
      stroke: color,
      fill: color,
    };
  }
}
